import React from "react";
import PropTypes from "prop-types";
import { Button, Modal, ModalBody } from "reactstrap";

const SpecialNotesModal = ({
    isOpen,
    onClose,
    candidateName = "",
    specialNotes = "",
}) => {
    const resolvedName = String(candidateName ?? "").trim() || "Candidate";
    const resolvedNotes = String(specialNotes ?? "").trim();

    return (
        <Modal
            isOpen={isOpen}
            toggle={onClose}
            backdrop="static"
            centered
            size="lg"
            className="special-notes-modal"
        >
            <ModalBody className="p-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="fw-bold mb-0">Special Notes — {resolvedName}</h5>
                    <Button close type="button" onClick={onClose} />
                </div>
                <div className="special-notes-box rounded p-3 modal-body-overflow">
                    {resolvedNotes ? (
                        <pre className="mb-0 text-wrap special-notes-modal__content">
                            {resolvedNotes}
                        </pre>
                    ) : (
                        <span className="text-muted">No special notes available.</span>
                    )}
                </div>
            </ModalBody>
        </Modal>
    );
};

SpecialNotesModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    candidateName: PropTypes.string,
    specialNotes: PropTypes.string,
};

export default SpecialNotesModal;
